import Store from 'redux/store';
import { trackingLTM } from '../clients';

import {
  FETCH_VENDORS,
  FETCH_VENDORS_FAIL,
  FETCH_VENDORS_SUCCESS,
} from 'redux/Reducers/Vendors/AvailableVendorsReducer';

export const FetchVendors = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_VENDORS });
  trackingLTM()
    .get(`/get-vendors`)
    .then(({ data }) => {
      Store.dispatch({
        type: FETCH_VENDORS_SUCCESS,
        payload: {
          data,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_VENDORS_FAIL,
        payload: {
          error: e,
        },
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
